import React from "react";
import moment from "moment-timezone";

const PageLevelViewPopup = ({
  isCanPrintViewPopup,
  selectedLanguage,
  latestUpdatedTime,
  dateFormatValueUpper,
  handleCloseCanPrintViewPopup,
  canPrintFilteredArr,
  timeZoneRef,
  applyTimeZoneToDisplay,
}) => {
  const historyRecipients = canPrintFilteredArr?.[0]?.lstDocumentRecipientDto ?? [];
  const recipients = (canPrintFilteredArr?.[0]?.documentOptions?.recipients ?? []).map(reader => {
    const historyReader = historyRecipients.find(x => x.email?.toLowerCase() === reader.email?.toLowerCase());
    return { ...reader, isChanged: historyReader?.isChanged ?? false };
  });
  if (!isCanPrintViewPopup) return null;
  return (
    <div className="child-popup" id="myModal">
      <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: "800px" }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="d-flex align-items-center mb-0" id="staticBackdropLabel">
              {selectedLanguage.LstLanguageCodes.UI_PrintRestrictions}
            </h5>
            <span style={{ fontWeight: "bold", marginLeft: "303px" }}>
              {selectedLanguage.LstLanguageCodes.UI_UpdateOn}:{" "}
              {latestUpdatedTime ? moment.utc(applyTimeZoneToDisplay(new Date(latestUpdatedTime), timeZoneRef?.current)).format(dateFormatValueUpper + " HH:mm") : "-"}
            </span>
            <button type="button" className="btn btn-outline-danger modalclose download" onClick={handleCloseCanPrintViewPopup}>
              <span className="material-icons font-20">highlight_off</span>
            </button>
          </div>
          <div
            className="modal-body"
            style={{ maxHeight: "60vh", overflow: "auto" }}>
            <table className="inertable page-restTh">
              <thead className="bg-lightblue">
                <tr>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_Email}
                  </th>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_Name}
                  </th>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_LabelPrint}
                  </th>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                  </th>
                </tr>
              </thead>
              <tbody>
                {recipients.map((reader, index) => (
                  <tr key={index} className={reader.isChanged ? "bgYellow" : ""}>
                    <td>{reader.email}</td>
                    <td>{(reader.firstName || "") + " " + (reader.lastName || "")}</td>
                    <td>{reader.canPrint ? selectedLanguage.LstLanguageCodes.UI_Enabled : selectedLanguage.LstLanguageCodes.UI_Disabled}</td>
                    <td>{(reader.maxPrintsPerReader != 0 ? reader.maxPrintsPerReader : "-") ?? "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLevelViewPopup;